<template>
  <div class="aim-cursor" ref="cursor">
    <span class="cross cross-top"></span>
    <span class="cross cross-right"></span>
    <span class="cross cross-bottom"></span>
    <span class="cross cross-left"></span>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const cursor = ref(null)

let mouseX = 0
let mouseY = 0

// 外圈当前位置
let ringX = 0
let ringY = 0

let rafId = null
let initialized = false

const moveCursor = (e) => {
  mouseX = e.clientX
  mouseY = e.clientY

  if (!cursor.value) return

  // 中间十字立即跟随
  cursor.value.style.left = mouseX + 'px'
  cursor.value.style.top = mouseY + 'px'

  // 初始化时让外圈也先到当前点，避免一开始从 0,0 飞过来
  if (!initialized) {
    ringX = mouseX
    ringY = mouseY
    cursor.value.style.setProperty('--ring-x', '0px')
    cursor.value.style.setProperty('--ring-y', '0px')
    initialized = true
  }
}

const animate = () => {
  if (cursor.value && initialized) {
    // 数值越小，延迟越明显
    const ease = 0.08

    // 外圈慢慢追向鼠标
    ringX += (mouseX - ringX) * ease
    ringY += (mouseY - ringY) * ease

    // 因为整个容器已经在鼠标位置，所以这里只需要设置相对偏移
    const offsetX = ringX - mouseX
    const offsetY = ringY - mouseY

    cursor.value.style.setProperty('--ring-x', `${offsetX}px`)
    cursor.value.style.setProperty('--ring-y', `${offsetY}px`)
  }

  rafId = requestAnimationFrame(animate)
}

onMounted(() => {
  window.addEventListener('mousemove', moveCursor)
  rafId = requestAnimationFrame(animate)
})

onUnmounted(() => {
  window.removeEventListener('mousemove', moveCursor)
  cancelAnimationFrame(rafId)
})
</script>

<style scoped>
.aim-cursor {
  --ring-x: 0px;
  --ring-y: 0px;
  position: fixed;
  left: 0;
  top: 0;
  width: 66px;
  height: 66px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 9999;
}

.aim-cursor::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%) translate(var(--ring-x), var(--ring-y));
  box-shadow:
    0 -28px 0 1px #fff,
    11px -26px 0 1px #fff,
    20px -20px 0 1px #fff,
    26px -11px 0 1px #fff,
    28px 0 0 1px #fff,
    26px 11px 0 1px #fff,
    20px 20px 0 1px #fff,
    11px 26px 0 1px #fff,
    0 28px 0 1px #fff,
    -11px 26px 0 1px #fff,
    -20px 20px 0 1px #fff,
    -26px 11px 0 1px #fff,
    -28px 0 0 1px #fff,
    -26px -11px 0 1px #fff,
    -20px -20px 0 1px #fff,
    -11px -26px 0 1px #fff;
}

.cross {
  position: absolute;
  background: #fff;
  border-radius: 1px;
}

.cross-top {
  left: 50%;
  top: 17px;
  width: 2px;
  height: 7px;
  transform: translateX(-50%);
}

.cross-bottom {
  left: 50%;
  top: 42px;
  width: 2px;
  height: 7px;
  transform: translateX(-50%);
}

.cross-left {
  top: 50%;
  left: 17px;
  width: 7px;
  height: 2px;
  transform: translateY(-50%);
}

.cross-right {
  top: 50%;
  left: 42px;
  width: 7px;
  height: 2px;
  transform: translateY(-50%);
}
</style>